<template>
  <!-- 外链文件 -->
  <div
    class="link-box"
    style="width: 100%; height: 100%"
  >
    <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
    <bs-structure
      :display-right="displayRightPanel"
      :is-full-screen="isFullScreen"
      :box-margin-r="0"
      :box-margin-l="0"
      :box-right-w="300"
    >
      <!-- header -->
      <template slot="boxHeader">
        <div
          v-if="!isFullScreen"
          class="preview-box-header"
        >
          <co-tips
            class="item"
            :content="$t('返回到文件所在的列表')"
            placement="right"
          >
            <span
              v-if="!isClient"
              class="go-back cp"
              @click="goBack"
            />
          </co-tips><!--
                --><div class="title-section">
                    <i class="icon-wrapper">
                        <svg class="icon-img">
                            <use :xlink:href="`#${getFileIcon()}`" />
                        </svg>
                    </i><!--
                --><bs-rename
:file-data="fileData"
@rename="rename"
@finish="finish"
/><!--
                --><div
v-if="!renaming"
class="tail-dec"
>
                        <div
v-show="fileData.isvirus"
class="virus-icon"
>
{{ $t('病毒') }}
</div>
                        <!-- <svg class="favorite-icon">
                            <use xlink:href="#iconStar"/>
                        </svg> -->
                        <svg
v-show="fileData.has_docs_lock"
class="favorite-icon"
>
                            <use xlink:href="#iconLock" />
                        </svg>
                    </div>
                    </div>
          <div
            id="btngroup"
            class="button-section lh-50"
          >
<!--
                        --><co-button
v-if="!banAccess"
self-class="right-pannel c-btn"
@click="toggleRightPanel"
>
                            <template name="default">
                                <svg class="right-pannel-icon">
                                    <use :xlink:href="displayRightPanel ? '#retractRightcolumn' : abnormalType==='noAccess'? '#disExpendRightcolumn':'#expendRightcolumn'" />
                                </svg>
                            </template>
                        </co-button>
          </div>
        </div>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <div class="link-box-body">
          <!--上部预览-->
          <div
            class="link-box-main"
            :style="{height:isShowFoot?'calc(100% - 50px)':'100%'}"
          >
            <!-- 正常预览 -->
            <bs-switch
              v-if="!abnormalType"
              ref="bsswitch"
              :is-side-mode="isSideMode"
              @loadFail="loadFail"
            />
            <!-- 异常预览提示 -->
            <bs-abnormal
              v-else
              :data="fileData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>
          <!--下部底部栏-->
          <div
            v-show="isShowFoot"
            class="link-box-footer"
          >
            <bs-PdftoolBar
              ref="pdftoolbar"
              :data="fileData"
              :doc-check="docCheck"
              @presentationMode="presentationMode"
            />
          </div>
          <!--外链下载-->
          <iframe
            id="download-iframe"
            src="javascript:false;"
            width="0"
            heigth="0"
            border="none"
            style="display:none"
          />
        </div>
      </template>
      <template slot="boxRight">
        <!--right panel-->
        <div
          v-show="displayRightPanel"
          class="link-right"
        >
          <bs-rpanel />
        </div>
      </template>
    </bs-structure>
  </div>
</template>
<script>
import bsStructure from 'components/business/structure/index.vue'
import coDoc from 'components/common/doc/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsRename from 'components/business/rename/index.vue'
import coMenu from 'components/common/menu/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import upMenu from 'components/business/upmenu/index.vue'
import coConfirm from 'components/common/confirm/index.vue'
import coDialog from 'components/common/dialog/index.vue'
import coTips from 'components/common/tips/index.vue'
import _$ from 'js/api/getdata.js'
import {
  typeIcon, isClient, _DOC_PERVIEW_PATH, isExcel,
} from 'js/util/util'
import coToast from 'components/common/toast/index.vue'
import bsRpanel from 'components/business/rpanel/index.vue'
import bsFeatureguide from 'components/business/featureguide/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'
import coButton from 'components/common/button/index.vue'
import { PREVIEW } from 'js/mixin/common.js'
import { bsFileDownLoad } from 'js/api/download/download.js'

export default {
  components: {
    bsStructure,
    coDoc,
    bsSwitch,
    coMenu,
    bsPdftoolBar,
    upMenu,
    coConfirm,
    coDialog,
    bsRename,
    coToast,
    bsRpanel,
    bsFeatureguide,
    bsAbnormal,
    coTips,
    coButton,
  },
  /**
         * 主要混入的函数
         * showFoot
         * footMouseMove
         * pushEsc
         * checkfull
         * loadFail
         */
  mixins: [PREVIEW],
  data() {
    return {
      show: true,
      // 文档类型选择
      typeList: [],
      // 全部类型
      allTypeList: [
        { name: '全部类型', key: 'all', type: -1 },
        { name: '图片', key: 'pic', type: 4 },
        { name: '文档', key: 'file', type: 1 },
        { name: '视频', key: 'video', type: 3 },
        { name: '音频', key: 'audio', type: 2 },
        { name: '其他', key: 'other', type: 0 },
      ],
      // 分享子菜单
      shareList: [
        { name: this.$t('新建链接'), key: 'commonLink' },
        { name: this.$t('新建安全链接'), key: 'secureLink' },
        { name: this.$t('新建SmartShare'), key: 'smartShare' },
        { name: this.$t('查看历史链接'), key: 'mgdelivery' },
      ],
      // 更多子菜单
      moreList: [
        { name: this.$t('预览'), key: 'preview' },
        { name: this.$t('本地编辑'), key: 'editNative' },
        { name: this.$t('本地编辑'), key: 'localEdit' },
        { name: this.$t('Docs编辑'), key: 'editOL' },
        { name: this.$t('共享管理'), key: 'auth' },
        { name: this.$t('收藏'), key: 'favorite' },
        { name: this.$t('取消收藏'), key: 'rmfavorite' },
        { name: this.$t('添加/编辑标签'), key: 'edittag' },
        { name: this.$t('历史版本'), key: 'history' },
        { name: this.$t('重命名'), key: 'rename' },
        { name: this.$t('移动/复制'), key: 'copymove' },
        { name: this.$t('锁定'), key: 'lock' },
        { name: this.$t('解锁'), key: 'unlock' },
        { name: this.$t('请求解锁'), key: 'reqUnlock' },
        { name: this.$t('删除'), key: 'delete' },
      ],
      displayRightPanel: false, // 默认收起右侧栏
      displayFooterScroller: false,
      displayTypeList: false,
      // 存放底部文件列表数据
      fileList: {
        currentPos: 0,
        content: [],
      },
      reqParam: {},
      // 是否有上一个
      hasPre: false,
      // 是否有下一个
      hasNext: false,
      // 记录上一个和下一个
      fileListStep: 0,
      // 文件类型选择器
      listVal: {
        type: '全部类型',
        curNum: 0,
        totalNum: 0,
      },
      renaming: false, // 重命名编辑状态
      // 是否显示弹框
      isDialog: false, // dialog显隐
      isConfirm: false, // confirm显隐
      test: '',
      selectedData: {},
      // 最近访问图片的上报
      recentImages: [],
      // 是否是幻灯片模式
      isSideMode: false,
      confirmData: { // confirm弹框
        isShow: false,
        title: '提示',
        content: '',
        sureBtn: '确认',
        onlyOne: false,
        isDescribe: false,
      },
      abnormalType: '',
      abnormalData: { // 异常页面所需的data
        maxSize: 0,
      },
      isShowFoot: true, // 是否显示底部操作栏
    }
  },
  computed: {
    /**
             * 是否为客户端
             */
    isClient() {
      return isClient()
    },
    /**
             * 当前选中文件的信息
             */
    fileData() {
      return this.$store.state.curFileInfo
    },
    /**
             * 是否显示幻灯片模式
             */
    isShowSlideBtn() {
      return this.fileData && (/ppt|dps/i.test(this.fileData.mime_type)) && !this.isClient
    },
    guideArr() {
      return this.$store.state.guideArr
    },
  },
  watch: {
    /**
             * 切换换灯片模式的预览
             */
    isSideMode(n, o) {
      this.$store.commit('GET_IS_SIDEMODE', n)
      this.$refs.bsswitch.init()
    },
  },
  async mounted() {
    const me = this
    // 添加了回调函数，在init中病毒文件附加属性的判断，触发在页面绘制完成之后。
    this.init(this.changeWidth)
    window.onbeforeunload = function (event) {
      me.sendRecentImg()
    }
    window.addEventListener('message', (e) => {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        me.abnormalType = 'loadFail'
      }
      if (e.data && e.data.type === 'complete') { // pdf完全加载成功
        me.iframeComplateLoad()
      }
    }, false)
    // 添加顶部文件标题尺寸互动监听
    window.addEventListener('resize', this.changeWidth)
  },
  created() {
    // 当多个新手引导时执行
    this.$store.dispatch('getGuide')
  },
  destroyed() {
    window.removeEventListener('resize', this.changeWidth)
  },
  methods: {
    /**
             * 检测预览是否超限
             */
    async checkFileLimit() {
      const param = {
        neid: this.$route.params.neid,
      }
      const data = await _$.getData('previewFileLimit', param)
      return data
    },
    /**
             * 获取文件extrameta信息，包括病毒，收藏，评论情况
             */
    async getExtraData() {
      const param = this.$route.params || {}
      const neid = +param.neid
      const extra = await _$.getData('extraMeta', { neids: JSON.stringify([neid]) })
      return extra
    },
    /**
             * 获取文件信息
             */
    async getMetaData() {
      const param = this.$route.params || {}
      const d = await _$.getData('getMetadata', { neid: param.neid })
      // this.$store.commit('GET_CUR_FILE_INFO',d.data)
      // return d.data
      return d
    },
    /**
             * merge extradata 和 meta
             * P.S. 这两个数据结构不一致,请在控制台打出来，看一看
             */
    mergeData(data) {
      const result = {} // 最终合并的数据
      data.forEach((item) => {
        let decoratedData = {}
        if (Object.keys(item.data).length <= 1) {
          decoratedData = item.data.content[0] || {}
          Object.assign(result, decoratedData)
        } else {
          decoratedData = item.data || {}
          Object.assign(result, decoratedData)
        }
      })
      // console.log('merge data：',result)
      this.$store.commit('GET_CUR_FILE_INFO', result)
      return result
    },
    /**
             * rename组件抛出事件，表示正在编辑状态，隐藏input框后面图标
             */
    rename(val) {
      this.renaming = val
    },
    /**
             * rename组件抛出事件，表示结束编辑状态，显示input框后面图标
             */
    finish(val) {
      this.renaming = val
    },
    /**
             * 更多操作
             */
    moreOperation(val) {
      // 删除，弹框
      if (val.key === 'delete') {
        this.isConfirm = true
      }
      if (val.key === 'reqUnlock') {
        this.isDialog = true
      }
    },
    /**
             * 删除弹框点击确认走删除功能
             */
    deletefile(val) {
      const info = JSON.stringify({ op_info: { neid: this.fileData.neid } })
      const data = {
        op: 'delete',
        ignore_share: false,
        auto_rename: false,
        info,
      }
      _$.postData('fileOp', data)
        .then((res) => {
        })
    },
    /**
             * toggle 右侧栏
             */
    toggleRightPanel() {
      this.displayRightPanel = !this.displayRightPanel
    },
    /**
             * 获取文件的类型
             */
    getFileIcon() {
      const mineType = this.fileData.mime_type || ''
      const icon = typeIcon(mineType.split('.').pop())
      return icon
    },
    /**
             *显示当前文件历史版本记录
             */
    showRevision() {
      const query = { from: this.$route.params.from, ...this.$route.query }
      const { href } = this.$router.resolve({
        name: _DOC_PERVIEW_PATH.sm_preview,
        params: { neid: this.$route.params.neid },
        query,
      })
      // 跳转界面
      location.href = href
    },
    /**
             * 获取文件的title
             */
    getTitle(val) {
      const path = val.split('/')
      const len = path.length
      return path[len - 1]
    },
    /**
             * 是否是图片
             */
    isImg(d) {
      return d.mime_type.indexOf('image') !== -1
    },
    /**
             * toggle 类型列表
             */
    toggleTypeList() {
      this.displayTypeList = !this.displayTypeList
    },
    /**
             * 返回按钮
             */
    goBack() {
      const par_neid = this.$route.query.par_neid || ''
      let other = this.$route.query.other || '{}'
      other = JSON.parse(other)
      // 跳转界面
      let { from } = this.$route.params
      if (from == 'search') {
        from = other.path_type || ''
      }
      window.location.href = `/v/list/${from}${par_neid ? `/${par_neid}` : ''}`
    },
    /**
             * 上报图片
             */
    sendRecentImg(d) {
      if (this.recentImages.length > 0) {
        const data = { fileType: 4, neids: this.recentImages }
        this.sendRecent(data)
      }
    },
    /**
             * 处理上报图片
             */
    handleRecentImg(neid) {
      if (this.recentImages.indexOf(neid)) {
        this.recentImages.push(neid)
      }
    },
    /**
             * 最近访问的上报
             */
    sendRecent(d) {
      Object.assign(d, { arrayFormat: true })
      _$.postData('sendRecent', d)
    },
    /**
             * 初始化预览信息
             * 请求文件信息如果有错出报错页面
             * 如果没错校验是否为大文件
             * @param {Boolean} getFileList 是否请求文件列表
             * @param 事件完成后的回调函数
             */
    async init(callback) {
      // 获取文件信息
      let data = {}
      try {
        // 并发请求metadata和extrameta
        const metaPromise = this.getMetaData()
        const extraPromise = this.getExtraData()
        const promiseArr = [metaPromise, extraPromise]
        const result = await Promise.all(promiseArr)
        data = this.mergeData(result)
        // 事件回调函数
        if (typeof callback === 'function') callback()
      } catch (e) {
        // 如果是404 说明文件被删了
        const errCfg = {
          403: { type: 'noAccess' }, // 无权限
          404: { type: 'delete' }, // 被删除
          500: { type: 'loadFail' }, // 加载失败
        }
        // 处理错误异常
        const res = e.response
        const { state } = res.data
        this.abnormalType = errCfg[state].type
        this.displayRightPanel = false
        this.isShowFoot = false // 不显示底部栏
        return
      }
      // 查检预览文件是否超限
      const fileLimit = (await this.checkFileLimit()).data
      if (!fileLimit.checkSizeResult) {
        this.abnormalData.maxSize = fileLimit.previewSizeLimit
        this.abnormalType = 'oversize'
        this.displayRightPanel = false // 关闭右侧栏
        this.isShowFoot = false // 不显示底部栏
        return
      }
      this.$refs.bsswitch.startPreview(data)
    },
    /**
             * 从url里的smOther参数里获取page参数
             */
    getSmOtherParam() {
      let smOther = {}
      try {
        smOther = JSON.parse(this.$route.query && this.$route.query.smOther)
      } catch (e) {
        return 1
      }
      return smOther.page_num || 1
    },
    /**
             * iframe完全加载成功
             */
    iframeComplateLoad() {
      if (this.$refs.pdftoolbar && typeof this.$refs.pdftoolbar.setPage === 'function') {
        if (this.getSmOtherParam && typeof this.getSmOtherParam === 'function') {
          const page = this.getSmOtherParam()
          this.$refs.pdftoolbar.setPage(page)
        }
      }
    },
    /**
             * 校验doc档预览
             * 超过文件限制，或者幻灯片模式是否要预览
             */
    docCheck() {
      if (!this.fileData) {
        return false
      }
      return !isExcel(this.fileData.mime_type) && !this.isSideMode && !this.abnormalType
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        back: 'goBack',
        download: 'downNewRevFile', // download
        refresh: 'refreshPreview', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
             * 下载最新版本的文件
             */
    downNewRevFile() {
      // 将当前metadata数据版本设置为空，必须未新对象防止污染旧对象
      const downData = { ...this.fileData }
      downData.rev = ''
      const downFile = { isDir: false, content: [downData] }
      bsFileDownLoad(downFile)
    },
    /**
             * failed to load, click 'refresh' to load it again
             */
    refreshPreview() {
      this.abnormalType = '' // 重置异常组件的显示
      this.init(false)
    },
    /** 计算顶部文件标题自适应宽度 */
    changeWidth() {
      // 注释掉了，按照固定最大450px宽度来，待优化title部分
      // let btngroup = document.getElementById('btngroup')     //获取按钮组件
      // if (btngroup) {
      //     this.$nextTick(() => {
      //         if (document.querySelector('.tail-dec')) {
      //             //返回箭头尺寸和ui间距12的和
      //             document.querySelector('.title-section').style.width = btngroup.getBoundingClientRect().left - 64 + 'px'
      //             //获取图标的宽度,2为边框属性
      //             let tailWidth = document.querySelector('.tail-dec').clientWidth + 2
      //             //104在64基础上面在加上文件图标测尺寸
      //             document.querySelector('.rename-section').style.maxWidth = btngroup.getBoundingClientRect().left - (104 + tailWidth) + 'px'
      //         }
      //     })
      // }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/link.less';
.link-box {
  .link-box-body{
    position: absolute;
  }
  .lh-50{
    .right-pannel{
      min-width: 32px;
      padding: 0;
      .right-pannel-icon{
        width: 24px;
        height: 24px;
        vertical-align: -6px;
        display: inline-block;
      }
    }
  }
}
// 以下代码是box.less和box中的style结合，未来可以合一起
.preview-box-header{
  height: 50px;
  line-height: 50px;
  width: 100%;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.15);
  position: relative;
  z-index: 80;
  .go-back{
    display: inline-block;
    line-height: 32px;
    height: 32px;
    width: 32px;
    border-radius: 2px;
    text-align: center;
    margin: 0 0 0 20px;
    cursor: pointer;
    &::before {
      content:url('~image/preOne.svg');
      display: inline-block;
      height: 24px;
      vertical-align: middle;
    }
    &:hover {
      background: #E8EBEF;
    }
    &:active {
      background: #C1C7CD;
    }
  }
  .title-section{
    display: inline-block;
    .icon-wrapper{
      width: 20px;
      height: 20px;
      display: inline-block;
      margin: 0 12px 0 8px;
      line-height: 20px;
      .icon-img{
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .virus-icon {
      line-height: 16px;
      border: 1px solid #FF1B43;
      font-size: 12px;
      color: #FF1B43;
      padding: 0 4px 0 4px;
      margin-left: 8px;
      border-radius: 2px;
      display: inline-block;
    }
    .tail-dec{
      height: 16px;
      display: inline-block;
      line-height: 16px;
      .favorite-icon{
        height: 16px;
        width: 16px;
        margin-bottom: -3px;
        margin-left: 8px;
      }
    }
  }

  .button-section{
    float: right;
    margin: 0 20px 0 0;
    .item-icon{
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
    .img-icon-wrapper{
      width: 32px;
      height: 32px;
    }
    .img-icon-wrapper-logo {
      width: 20px;
      height: 20px;
      vertical-align: text-bottom;
    }
    .item-icon-more{
      width: 15px;
      height: 14px;
    }
  }
}
</style>
